module.exports = __webpack_public_path__ + "static/media/craft.3663cfc9.png";